import { Intent, Position, Toaster } from '@blueprintjs/core'

export const toaster = Toaster.create({
  className: 'app-toaster',
  position: Position.TOP
})

export function showToast(message, intent: Intent = Intent.SUCCESS, goToTop = true, timeout = 2000) {
  if (goToTop) window.scrollTo(0, 0)
  toaster.show({ message, intent, timeout })
}

export function showSuccess(message, intent: Intent = Intent.SUCCESS, goToTop = true) {
  showToast(message, intent, goToTop, 1500)
}

// message: message to display
// timeout: in milliseconds
export function showFailure(message, timeout = 5000, goToTop = true) {
  showToast(message, Intent.DANGER, goToTop, timeout)
}

export function showBulkResponseToast(data, getSuccessMessage, getFailureMessage, getNoChangeMessage) {
  const count = arr => (arr && arr.length) || 0
  const successCount = count(data.successfulIds)
  const failCount = count(data.failedIds)
  if (successCount || failCount) {
    // There may be useful info in both messages. It could be inappropriate to clobber them together, so just make 2 toasts.
    if (successCount) {
      showToast(getSuccessMessage(successCount))
    }
    if (failCount) {
      showFailure(getFailureMessage(failCount), 10000)
    }
  } else if (getNoChangeMessage) {
    showToast(getNoChangeMessage(), Intent.DANGER)
  }
}
